export const UserPermission = Object.freeze({
    READ_PERMISSIONS: 'read_permissions',
    READ_GROUPS: 'read_groups',
    WRITE_GROUPS: 'write_groups',
    DELETE_GROUPS: 'delete_groups',
    READ_PERMISSION_USER: 'read_permission_user',
    WRITE_PERMISSIONS_USER: 'write_permission_user',
    READ_DEPARTMENT: 'read_departments',
    WRITE_DEPARTMENT: 'write_departments',
    DELETE_DEPARTMENT: 'delete_departments',
    UPLOAD_FILE: 'upload_file',
    DOWNLOAD_FILE: 'download_file',
    READ_COMPANY: 'read_company',
    WRITE_COMPANY: 'write_company',
    DELETE_COMPANY: 'delete_company',
    READ_USERS: 'read_users',
    WRITE_USERS: 'write_users',
    DELETE_USERS: 'delete_users',
    READ_MFA: 'read_mfa',
    WRITE_MFA: 'write_mfa',
    READ_THEME: 'read_theme',
    READ_DEFAULT_THEME: 'read_default_theme',
    WRITE_THEME: 'write_theme',
    DELETE_THEME: 'delete_theme',
    READ_SOURCE: 'read_source',
    WRITE_SOURCE: 'write_source',
    DELETE_SOURCE: 'delete_source',
    READ_DEFAULT_SOURCE: 'read_default_source',
    READ_INCIDENT_TYPE: 'read_incident_type',
    WRITE_INCIDENT_TYPE: 'write_incident_type',
    DELETE_INCIDENT_TYPE: 'delete_incident_type',
    READ_CALLSIGN: 'read_callsign',
    WRITE_CALLSIGN: 'write_callsign',
    DELETE_CALLSIGN: 'delete_callsign',
    READ_INCIDENT: 'read_incident',
    WRITE_INCIDENT: 'write_incident',
    DELETE_INCIDENT: 'delete_incident',
    READ_DEBRIEF: 'read_debrief',
    WRITE_DEBRIEF: 'write_debrief',
    DELETE_DEBRIEF: 'delete_debrief',
    READ_LEARNING_OUTCOME: 'read_learning_outcome',
    WRITE_LEARNING_OUTCOME: 'write_learning_outcome',
    DELETE_LEARNING_OUTCOME: 'delete_learning_outcome',
    READ_USER_DEPARTMENT: 'read_user_department',
    WRITE_USER_DEPARTMENT: 'write_user_department',
    READ_TASK: 'read_task',
    WRITE_TASK: 'write_task',
    DELETE_TASK: 'delete_task',
    LINK_TASK_TO_LEARNING_OUTCOME: 'link_task_to_learning_outcome',
    GLOBAL_TASK_FORCE: 'global_task_force',
    READ_TASK_COMMENT: 'read_task_comment',
    WRITE_TASK_COMMENT: 'write_task_comment',
    DELETE_TASK_COMMENT: 'delete_task_comment',
    TASK_COMMENT_MODERATOR: 'task_comment_moderator',
    READ_DEBRIEF_REPORT: 'read_debrief_report',
    WRITE_SEND_TO_JOL: 'write_send_to_jol',
    WRITE_SEND_TO_NOL: 'write_send_to_nol',
    WRITE_SEND_TO_ROL: 'write_send_to_rol',
    READ_DEBRIEF_APPLIANCE_REPORT: 'read_debrief_appliance_report',
    READ_DEBRIEF_LEARNING_IDENTIFIED_REPORT: 'read_debrief_learning_identified_report',
    READ_LEARNING_OUTCOME_SHARED_REPORT: 'read_learning_outcome_shared_report',
    READ_LEARNING_OUTCOME_THEME_REPORT: 'read_learning_outcome_theme_report',
    READ_TASK_DEPARTMENT_REPORT: 'read_task_department_report',
    READ_TASK_PRIORITY_REPORT: 'read_task_priority_report',
    READ_TASK_PROGRESS_REPORT: 'read_task_progress_report',
    READ_TASK_THEME_REPORT: 'read_task_theme_report',
    READ_DEBRIEF_BY_MONTH_REPORT: 'read_debrief_by_month_report',
    READ_PRODUCT: 'read_product',
    READ_LICENCE: 'read_licence',
    READ_ASSESSMENT_ATTRIBUTE_CATEGORY: 'read_assessment_attribute_category',
    WRITE_ASSESSMENT_ATTRIBUTE_CATEGORY: 'write_assessment_attribute_category',
    DELETE_ASSESSMENT_ATTRIBUTE_CATEGORY: 'delete_assessment_attribute_category',
    READ_ASSESSMENT_ATTRIBUTE_TAG: 'read_assessment_attribute_tag',
    READ_ASSESSMENT_ATTRIBUTE_RULE: 'read_assessment_attribute_rule',
    READ_ASSESSMENT_ATTRIBUTES: 'read_assessment_attributes',
    WRITE_ASSESSMENT_ATTRIBUTES: 'write_assessment_attributes',
    DELETE_ASSESSMENT_ATTRIBUTES: 'delete_assessment_attributes',
    READ_ASSESSMENT_BLOCKS: 'read_assessment_blocks',
    WRITE_ASSESSMENT_BLOCKS: 'write_assessment_blocks',
    DELETE_ASSESSMENT_BLOCKS: 'delete_assessment_blocks',
    READ_ASSESSMENT_CATEGORY: 'read_assessment_category',
    WRITE_ASSESSMENT_CATEGORY: 'write_assessment_category',
    DELETE_ASSESSMENT_CATEGORY: 'delete_assessment_category',
    READ_ASSESSMENT: 'read_assessment',
    WRITE_ASSESSMENT: 'write_assessment',
    DELETE_ASSESSMENT: 'delete_assessment',
    READ_ASSESSMENT_FORM: 'read_assessment_form',
    WRITE_ASSESSMENT_FORM: 'write_assessment_form',
    DELETE_ASSESSMENT_FORM: 'delete_assessment_form',
    SHARE_EXERCISE: 'share_exercise',
    WRITE_ASSESSMENT_RESULT_TEMPLATE: 'write_assessment_result_template',
    READ_ASSESSMENT_RESULT_TEMPLATE: 'read_assessment_result_template',
    DELETE_ASSESSMENT_RESULT_TEMPLATE: 'delete_assessment_result_template',
    READ_FORMULAS: 'read_formulas',
    WRITE_FORMULAS: 'write_formulas',
    DELETE_FORMULAS: 'delete_formulas',
    APPOINT_AS_MANAGER: 'appoint_as_manager',
    REMOVE_FROM_MANAGER: 'remove_from_manager',
    READ_USER_GROUP: 'read_user_group',
    WRITE_USER_GROUP: 'write_user_group',
    DELETE_USER_GROUP: 'delete_user_group',
    READ_TASK_DYNAMIC_REPORT: 'read_task_dynamic_report',
    READ_DEBRIEF_DYNAMIC_REPORT: 'read_debrief_dynamic_report',
    READ_METRIC: 'read_metric',
    WRITE_METRIC: 'write_metric',
    DELETE_METRIC: 'delete_metric',
    TASK_DELEGATE: 'task_delegate',
    READ_GROUP_PERMISSION_USER: 'read_group_permission_user',
    READ_USER_PROFILE_ATTRIBUTES: 'read_user_profile_attributes',
    WRITE_USER_PROFILE_ATTRIBUTES: 'write_user_profile_attributes',
    DELETE_USER_PROFILE_ATTRIBUTES: 'delete_user_profile_attributes',
    READ_CHECKLIST_TYPE: 'read_checklist_types',
    WRITE_CHECKLIST_TYPE: 'write_checklist_type',
    READ_CHECKLIST: 'read_checklists',
    WRITE_CHECKLIST: 'write_checklist',
    WRITE_CHECKLIST_ITEMS: 'write_checklist_items',
    WRITE_CHECKLIST_RESPONSE: 'write_checklist_response',
    DELETE_CHECKLIST: 'delete_checklist',
    READ_STATION: 'read_stations',
    WRITE_STATION: 'write_station',
    DELETE_STATION: 'delete_station',
});
